export default __webpack_public_path__ + "static/media/end-call.0d5e5b21.svg";